import { Component, ElementRef, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { DrawingTools, ExpandableTool, PanZoomTools, ROITools, RotationTools, SpineTools, WindowingTools } from '../expandableTools';

@Component({
  selector: 'app-visor-context-menu',
  templateUrl: './visor-context-menu.component.html',
  styleUrls: ['./visor-context-menu.component.css']
})
export class VisorContextMenuComponent implements OnInit {

  @ViewChild('ContextMenuContainer') container: ElementRef | undefined;
  @Output('activateTool') activateToolEmitter = new EventEmitter<{ func: any, args: string[] }>();

  location: { x: number, y: number } = { x: 0, y: 0 };
  isOpen = false;
  public expandableTools: ExpandableTool[] = [];

  yOpen: 'top' | 'down' | 'allTop' = 'down';
  xOpen: 'left' | 'right' | 'allLeft' = 'right'

  get subToolsClassList() {
    let classes = 'sub-tool-container ';
    if (this.xOpen == 'right') {
      classes += 'right ';
    } else {
      classes += 'left ';
    }
    if (this.yOpen == 'down') {
      classes += 'bottom ';
    } else {
      classes += 'top ';
    }
    return classes;
  }

  constructor() { }

  ngOnInit(): void {
    this.expandableTools = [WindowingTools, RotationTools, PanZoomTools, ROITools, DrawingTools, SpineTools];
  }

  open(event: PointerEvent) {
    this.location = { x: event.offsetX, y: event.offsetY }
    const rightSpace = window.innerWidth - event.clientX
    const bottomSpace = window.innerHeight - event.clientY
    console.log('rightSpace', rightSpace);
    console.log('bottomSpace', bottomSpace);

    if (rightSpace < 355) {
      this.xOpen = 'left';
      if (rightSpace < 155) {
        this.xOpen = 'allLeft';
      }
    } else {
      this.xOpen = 'right';
    }
    if (bottomSpace < 570) {
      this.yOpen = 'top';
      if (bottomSpace < 215) {
        this.yOpen = 'allTop';
      }
    } else {
      this.yOpen = 'down';
    }

    if (this.xOpen == 'allLeft') {
      this.location.x -= 150;
    }
    if (this.yOpen == 'allTop') {
      this.location.y -= 212;
    }
    console.log('this.xopen', this.xOpen);
    console.log('this.yopen', this.yOpen);

    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }

  sendActivateTool(tool: typeof WindowingTools.tools[0]) {
    this.activateToolEmitter.emit({ func: tool.func, args: tool.args });
  }

}
